import { useEffect, useState } from "react";
import { Button } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/24/outline";
import ModalFrame from "../../components/ModalFrame";
import { EditPeerReviewGroupForm } from "./EditPeerReviewGroupForm";
import {
	useLazyAddGroupQuery,
	useAddGroupMutation,
	EditReviewGroupModel,
} from "./peerReviewGroupsApiSlice";

interface CreatePeerReviewGroupButtonProps {
	disabled: boolean;
	onClick: () => void;
}
export function CreatePeerReviewGroupButton(props: CreatePeerReviewGroupButtonProps) {
	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const handleClick = () => {
		props.onClick();
		setIsDialogOpen(true);
	};

	const handleDialogClose = () => setIsDialogOpen(false);

	return (
		<>
			<Button
				id="create-group-button"
				className="btn btn-neutral mr-2"
				disabled={props.disabled}
				onClick={() => handleClick()}>
				<span className="flex items-center">
					<PlusIcon className="size-4 mr-2" /> Add Group
				</span>
			</Button>

			{isDialogOpen && (
				<CreatePeerReviewGroupDialog
					isDialogOpen={isDialogOpen}
					onClose={handleDialogClose}
				/>
			)}
		</>
	);
}

interface CreatePeerReviewGroupDialogProps {
	isDialogOpen: boolean;
	onClose: () => void;
}

export function CreatePeerReviewGroupDialog(props: CreatePeerReviewGroupDialogProps) {
	const [addGroupData, setAddGroupData] = useState<EditReviewGroupModel>();
	const [callGetAddGroup] = useLazyAddGroupQuery();
	const [callPostAddGroup] = useAddGroupMutation();

	useEffect(() => {
		if (props.isDialogOpen) {
			callGetAddGroup()
				.unwrap()
				.then((result) => {
					setAddGroupData(result);
				})
				.catch((error: any) => {
					console.log(error);
				});
		}
	}, [props.isDialogOpen]);

	function handleSubmit(model: EditReviewGroupModel) {
		var errorMessage = "";
		callPostAddGroup(model)
			.unwrap()
			.then(() => {
				props.onClose();
			})
			.catch((error: any) => {
				console.log(error);
				errorMessage = error.data;
			});
		return errorMessage;
	}

	return (
		addGroupData && (
			<ModalFrame
				open={props.isDialogOpen}
				title="Create Review Group"
				overflow="overflow-visible"
				onClose={() => props.onClose()}>
				<EditPeerReviewGroupForm
					initialGroupData={addGroupData}
					submitLabel="Create Group"
					onSubmit={handleSubmit}
					onClose={props.onClose}
				/>
			</ModalFrame>
		)
	);
}
